import { Map } from 'immutable';

import {
    SET_JOBS_SUMMARY,
    SET_ACCOUNTS,
} from './actions';

const defaultFilters = Map({
    jobsList: [],
    accounts: [],
});

export default (state = Map(defaultFilters), action) => {
  switch (action.type) {
    case SET_JOBS_SUMMARY:
        return state.set('jobsList', action.payload.jobsList);
    case SET_ACCOUNTS:
        return state.set('accounts', action.payload.accounts);
    default:
        return state;
  }
}


// WEBPACK FOOTER //
// ./src/admin/reducers.js